import useTheme from "../hooks/useTheme";

const XIconSvg = () => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M2.21094 22.2903L21.7912 2.70996M2.21094 2.70996L21.7912 22.2903"
        stroke="#070D0F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default XIconSvg;
